module.exports = __webpack_public_path__ + "static/media/serv1.35ddc4d5.png";